import { useMemo } from "react";

import AddPageSubMenu from "src/components/layouts/AddPageSubMenu";
import { createInstitutionSettingsSubMenu } from "src/routing/navigation";

/**
 * Registers the institution settings submenu through the shared layout adapter.
 *
 * Postconditions: A rendered registration requests layout updates after render and removes its
 * submenu code on cleanup. Navigation factories retain responsibility for link metadata.
 * Static metadata is memoized for this mounted instance; it is not reloaded on each render.
 */
const InstitutionSettingsSubMenu: React.FC = () => {
    const subMenu = useMemo(
        () => {
            return createInstitutionSettingsSubMenu();
        },
        []
    );

    if (!subMenu) {
        return null;
    }

    return <AddPageSubMenu subMenu={subMenu} />;
};

export default InstitutionSettingsSubMenu;
